<template>
  <v-container class="justify-center pa-0">
    <v-card max-width="640" class="mx-auto notification-card">
      <h2>New Notifications</h2>
      <p v-if="newNotifications.items.length === 0" class="no-new-notifications-message">
        you have no new notifications at this time
      </p>
      <notification-entry
        v-for="notification in newNotifications.items"
        :key="notification.id"
        :notification="notification"
        @friend-request-accepted="handleFriendRequestAccepted(notification)"
      ></notification-entry>
      <button
        v-if="newNotifications.hasMoreItems"
        class="button-text-gray-underlined load-more"
        @click="getNotifications(false)"
      >
        load more
      </button>
      <template v-if="oldNotifications.items.length > 0">
        <h2>Older Notifications</h2>
        <notification-entry
          v-for="notification in oldNotifications.items"
          :key="notification.id"
          :notification="notification"
          @friend-request-accepted="handleFriendRequestAccepted(notification)"
        ></notification-entry>
        <button
          v-if="oldNotifications.hasMoreItems"
          class="button-text-gray-underlined load-more"
          @click="getNotifications(true)"
        >
          load more
        </button>
      </template>
    </v-card>
  </v-container>
</template>

<script>
import notificationEntry from "@/components/notifications/notification-entry.vue";
import { FRIEND_REQUEST_STATUSES } from "../util/constants";
const MAX_NOTIFICATION_UPDATES_PER_REQUEST = 20;

export default {
  name: "notifications-age",

  components: { notificationEntry },

  data: () => ({
    FRIEND_REQUEST_STATUSES,

    notificationResponseLimit: 5,
    newNotifications: {
      hasMoreItems: false,
      items: [],
    },
    oldNotifications: {
      hasMoreItems: false,
      items: [],
    },
  }),

  mounted() {
    this.getInitialNotifications();
  },

  async beforeRouteLeave(to, from, next) {
    // Mark all new notifications as read
    let requestPromises = [];
    for (let i = 0; i < this.newNotifications.items.length; i += MAX_NOTIFICATION_UPDATES_PER_REQUEST) {
      requestPromises.push(
        this.$axios.patch("/v1/notifications/read", {
          notifications: this.newNotifications.items.map((item) => ({ id: item.id })),
        }),
      );
    }
    // Do not throw an error if one or more requests fail. continue navigating away
    await Promise.allSettled(requestPromises);
    this.$store.commit("setNotifications", { count: this.newNotifications.hasMoreItems ? 1 : 0 });

    await next();
  },

  methods: {
    async getInitialNotifications() {
      await this.getNotifications(true);
      await this.getNotifications(false);
    },

    async getNotifications(read) {
      const notificationResponse = await this.$axios.get("/v1/notifications", {
        params: {
          read,
          limit: this.notificationResponseLimit,
          offset: read ? this.oldNotifications.items.length : this.newNotifications.items.length,
        },
      });
      if (read) {
        this.oldNotifications.items = this.oldNotifications.items.concat(notificationResponse.data.items);
        this.oldNotifications.hasMoreItems = notificationResponse.data.hasMoreItems;
      } else {
        this.newNotifications.items = this.newNotifications.items.concat(notificationResponse.data.items);
        this.newNotifications.hasMoreItems = notificationResponse.data.hasMoreItems;
      }
    },

    handleFriendRequestAccepted(notification) {
      notification.notificationData.requestStatus = FRIEND_REQUEST_STATUSES.APPROVED;
    },
  },
};
</script>

<style scoped>
.notification-card {
  padding: 8px;
  position: relative;
}

h2 {
  line-height: 1;
  font-size: 32px;
  color: var(--v-text-lighten1);
  font-weight: normal;
  margin-bottom: 12px;
}

h2:not(:first-child) {
  margin-top: 24px;
}

.no-new-notifications-message {
  text-align: center;
  color: var(--v-text-lighten1);
  font-size: 20px;
  margin-bottom: 0;
}

.load-more {
  display: block;
  inline-size: max-content;
  margin: auto;
}

.load-more:hover {
  font-weight: 500;
}
</style>
